import { render, staticRenderFns } from "./RichTextAreaField.vue?vue&type=template&id=98141550&"
import script from "./RichTextAreaField.vue?vue&type=script&lang=js&"
export * from "./RichTextAreaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports